import { PaymentStatus } from '../../event/models/payment-status.enum';

export class EventStatusInfo {
    private readonly paymentStatus = PaymentStatus.READY.toString();

  public constructor(status?: string) {
    if (status) {
      this.paymentStatus = status.toLowerCase().toString();
    }
  }

    public getStatus(): string {
        return this.paymentStatus;
    }

    public isCancelled(): boolean {
      return this.paymentStatus === PaymentStatus.CANCELLED.toString();
    }

    public isUnpaid(): boolean {
        return this.paymentStatus === PaymentStatus.ERROR.toString() ||
                this.paymentStatus === PaymentStatus.PAY_REJECTED.toString() ||
                this.paymentStatus === PaymentStatus.CHECK_STOPPED.toString() ||
                this.paymentStatus === PaymentStatus.INVOICE_REJECTED.toString() ||
                this.paymentStatus === PaymentStatus.REQUESTED.toString() ||
                this.paymentStatus === PaymentStatus.REQUEST_REJECTED.toString() ||
                this.paymentStatus === PaymentStatus.RESENT_REQUEST.toString() ||
                this.paymentStatus === PaymentStatus.CHECK_STOPPED.toString() ||
                this.paymentStatus === PaymentStatus.UNPAID.toString();
    }

    public isPaid(): boolean {
        return this.paymentStatus === PaymentStatus.PAID_DIRECT.toString() ||
          this.paymentStatus === PaymentStatus.PAY_SENT.toString() ||
          this.paymentStatus === PaymentStatus.PAY_CLEARED.toString() ||
          this.paymentStatus === PaymentStatus.PAY_REISSUED.toString() ||
          this.paymentStatus === PaymentStatus.PAID.toString();
    }

    public isProcessing(): boolean {
      return this.paymentStatus === PaymentStatus.READY.toString() ||
        this.paymentStatus === PaymentStatus.PENDING.toString() ||
        this.paymentStatus === PaymentStatus.PENDING.toString() ||
        this.paymentStatus === PaymentStatus.FUNDED.toString() ||
        this.paymentStatus === PaymentStatus.PAY_REISSUED.toString() ||
        this.paymentStatus === PaymentStatus.INVOICED.toString() ||
        this.paymentStatus === PaymentStatus.PARTIAL.toString();
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/event-status-info.ts